<template lang="pug">
div
  NavBar
    .main
      #present-row.row
      .row
        .tab-row
          a(
            :class="{'active': currentTab == 'present'}"
            @click.stop="currentTab = 'present'") 分析报告
          a(
            :class="{'active': currentTab == 'account'}"
            @click.stop="currentTab = 'account'") 账户优化
      .row(
        v-if="currentTab !== 'present'"
        )
        table.account
          tr(v-for="item,index in accountItems")
            td.cell
              .manual-text(:data-index="index+1") {{item.title}}
              .desc
                span.text(v-if="item.context") {{item.context}}
                ol.sub-text(v-if="item.des.length > 0")
                  li(v-if="item.context")
                  li(v-for="des,desIndex in item.des")
                    span.text {{des.text}}
                span.tag-notice(
                    v-if="item.notice"
                  ) 注意：{{item.notice}}
            td.cell.img-cell.txt-right(:class="{'pt20': index == 0}")
              img(:src="item.img")

      .row(
        v-else
        v-for="item,index in presentItems")
        table.present
          tr
            td.cell.txt-left(v-if="index%2 !== 0")
              img(:src="item.img")
            td.cell
              .title {{item.title}}
              .des(v-for="des in item.des")
                .subtitle {{des.subtitle}}
                .text {{des.text}}
            td.cell.txt-right(v-if="index%2 === 0")
              img(:src="item.img")
  .ft
    .footer-container
      .little-person
    site-footer
</template>
<script>
import { PresentItem, AccountItem } from './constants.js'
import NavBar from '../component/navbar.vue'
export default {
  components: {
    NavBar
  },
  mounted () {
    document.querySelector('.header').style.backgroundColor = 'transparent'
    window.onscroll = (e) => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollHeight > 400) {
        document.querySelector('.header').style.backgroundColor = '#222'
      } else {
        document.querySelector('.header').style.backgroundColor = 'transparent'
      }
    }
  },
  data () {
    return {
      currentTab: 'present',
      presentItems: PresentItem,
      accountItems: AccountItem
    }
  }
}
</script>
<style scoped>
.row {
  background: #fff;
}
.tab-row {
  text-align: center;
  margin-top: 20px;
  a {
    display: inline-block;
    width: 290px;
    line-height: 50px;
    font-size: 26px;
    font-weight: normal;
    box-shadow: 0 5px 5px -3px rgba(0,0,0,0.1);
    &:hover,
    &.active {
      color: rgb( 86, 191, 139 );
      border-bottom: 2px solid rgb( 86, 191, 139 );
    }
  }
}
#present-row {
    position: relative;
    height: 500px;
    background: url("https://p1.ssl.qhimg.com/t01a144bca0b3e12c35.png") no-repeat center;
    background-size: cover
}
.present,
.account {
    width: 1200px;
    height: 500px;
    margin: 0 auto
}

.account .cell,
.present .cell {
    width: 50%;
    display: inline-block;
    padding-top: 50px
}

.account tr {
  height: 480px;
  vertical-align: top;
}
.account .desc {
  margin-left: 80px;
  li {
    line-height: 30px;
    margin-bottom: 15px;
    font-size: 20px;
    list-style-type: upper-alpha;
    color: rgb( 217, 169, 111 );
  }
}
.present .cell .title {
    font-size: 26px;
    color: #363f4d;
    padding-bottom: 60px
}

.present .cell .des {
    font-size: 16px;
    margin-bottom: 30px
}

.present .cell .des .subtitle {
    display: inline-block;
    color: #444;
    font-weight: bold
}

.present .cell .des .text {
    display: inline;
    color: #666
}
.footer-container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.little-person {
    position: absolute;
    right: 0;
    bottom: -51px;
    width: 50px;
    height: 150px;
    background: url(https://p3.ssl.qhimg.com/t01192875a5bf441445.png) no-repeat;
}
.txt-left {
  text-align: left;
}
.txt-right {
  text-align: right;
}
.account td {
  position: relative;
}
.manual-text {
    position: relative;
    margin: 30px 0 15px 80px;
    word-wrap: break-word;
    word-break: normal;
    font-size: 24px;
}
.manual-text::before {
    content: attr(data-index);
    position: absolute;
    left: -80px;
    top: -10px;
    display: inline-block;
    width: 50px;
    line-height: 50px;
    font-size: 30px;
    border: 1px solid rgb( 230, 235, 242 );
    border-radius: 50%;
    text-align: center;
    background: rgb( 230, 235, 242 );
    margin-right: 10px;
    color: #fff;
}
.text {
  font-size: 16px;
  color: rgb( 102, 102, 102 );
}
.tag-index,
.tag-notice {
  margin-right: 5px;
  font-size: 20px;
  color: rgb( 217, 169, 111 );
}
.tag-notice {
  font-size: 16px;
}
.sub-text {
  margin-left: 20px;
}
.account .pt20 {
  padding-top: 70px;
}
</style>



// WEBPACK FOOTER //
// present.vue?352aef74